import { CartAddEvent } from '@theme/events';

(function () {
  if (window.__TeakCardAddToCartInit) return;
  window.__TeakCardAddToCartInit = true;

  function cartSectionIds() {
    const ids = [];
    document.querySelectorAll('cart-items-component').forEach((item) => {
      if (item instanceof HTMLElement && item.dataset.sectionId && !ids.includes(item.dataset.sectionId)) {
        ids.push(item.dataset.sectionId);
      }
    });
    return ids;
  }

  function fetchCart() {
    const root = window.Shopify?.routes?.root || '/';
    return fetch(`${root}cart.js`).then((response) => response.json());
  }

  function themeRoutes() {
    if (typeof Theme !== 'undefined' && Theme.routes) return Theme.routes;
    return window.Theme?.routes || {};
  }

  function setLabel(button, text) {
    const label = button.querySelector('[data-teak-card-atc-label]');
    if (label) label.textContent = text;
  }

  function setBusy(button, busy) {
    button.disabled = busy;
    button.dataset.busy = busy ? 'true' : 'false';
    button.setAttribute('aria-busy', busy ? 'true' : 'false');
  }

  function showTemporaryLabel(button, text, delay = 1400, state) {
    setLabel(button, text);
    if (state) button.dataset.state = state;
    window.setTimeout(() => {
      setLabel(button, button.dataset.label || 'Add to cart');
      if (state) delete button.dataset.state;
    }, delay);
  }

  async function addToCart(button) {
    const routes = themeRoutes();
    if (!routes.cart_add_url) return;
    if (button.dataset.busy === 'true' || button.disabled) return;

    const variantId = Number(button.dataset.variantId);
    if (!variantId) return;

    const quantity = Math.max(1, Number(button.dataset.quantity) || 1);
    const sections = cartSectionIds();

    setBusy(button, true);
    setLabel(button, 'Adding...');

    try {
      const response = await fetch(routes.cart_add_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          items: [{ id: variantId, quantity }],
          sections: sections.join(','),
          sections_url: window.location.pathname,
        }),
      }).then((res) => res.json());

      if (response.status) {
        throw new Error(response.description || response.message || 'Unable to add to cart.');
      }

      const cart = await fetchCart();
      document.dispatchEvent(
        new CartAddEvent(cart, String(variantId), {
          source: 'teak-card-add-to-cart',
          productId: button.dataset.productId,
          variantId: String(variantId),
          itemCount: cart?.item_count || quantity,
          sections: response.sections || {},
        })
      );

      showTemporaryLabel(button, button.dataset.addedLabel || 'Added', 1400, 'added');
    } catch (error) {
      console.error(error);
      showTemporaryLabel(button, 'Try again', 1800, 'error');
    } finally {
      setBusy(button, false);
    }
  }

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest('[data-teak-card-atc]');
      if (!button) return;

      event.preventDefault();
      event.stopPropagation();
      addToCart(button);
    },
    true
  );
})();
